import React, { useState, useEffect } from 'react'
import Reusabletable from '../reusableforms/Reusabletable'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import files from "./../../../../assets/templates/register_template/CTC_master.xlsx"
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileformInputMatrix from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrix'
import ImportFileformInputMatrixclientData from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrixclientData'
import mainicon from "../../../../assets/register_assets/inputMatix/CTC_Master/mainicon.png"
import { getCurrentMonth } from './../../../../services/global_redux/globale_actions/Currentmonth.action';
import Basic_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Basic_icon.png"
import Employee_code_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Employee_code_icon.png"
import Branch_id_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Branch_id_icon.png"
import Client_id_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Client_id_icon.png"
import Comp_others_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Comp_others_icon.png"
import Conveyance_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Conveyance_icon.png"
import DA_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/DA_icon.png"
import Damage_loss_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Damage_loss_icon.png"
import Employee_name_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Employee_name_icon.png"
import ESI_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/ESI_icon.png"
import Fines_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Fines_icon.png"
import Gross_salary_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Gross_salary_icon.png"
import HRA_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/HRA_icon.png"
import LWF_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/LWF_icon.png"
import Maternity_Benefits_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Maternity_Benefits_icon.png"
import Medical_Allowance_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Medical_Allowance_icon.png"
import Mode_of_pay_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Mode_of_pay_icon.png"
import NFH_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/NFH_icon.png"
import OT_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/OT_icon.png"
import others_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/others_icon.png"
import Payment_month_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Payment_month_icon.png"
import PF_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/PF_icon.png"
import PT_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/PT_icon.png"
import Salary_advance_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Salary_advance_icon.png"
import Service_weightage_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Service_weightage_icon.png"
import Society_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Society_icon.png"
import Special_allowance_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Special_allowance_icon.png"
import ST_bonus_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/ST_bonus_icon.png"
import TDS_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/TDS_icon.png"
import Total_deduction_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Total_deduction_icon.png"
import Net_pay_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Net_pay_icon.png"
import Insurance_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/Insurance_icon.png"
import subsistence_allowance_icon from "../../../../assets/register_assets/inputMatix/CTC_Master/subsistence_allowance_icon.png"

import { uploadCtcMasterFile, getCtcMaster, updateCtcMasterById, deleteCtcMasterById, multiDeleteCtcMasterFile } from './../../../../services/register_redux/register_actions/CtcMaster.action';
import { getUserRole } from "./../../../../services/global_redux/globale_actions/Role.action";

function CtcMaster({ setLoading, showSnackbar }) {
    const [getData, setGetData] = useState([])
    const [file, setFile] = useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({})
    const dispatch = useDispatch();
    const { date } = useParams();
    const [createData, setCreateData] = useState(null);
    const [editData, setEditData] = useState(null);
    const [deleteData, setDeleteData] = useState(null);
    const header = [
        { key: "emp_code", value: "Employee Code" , readOnly:true , icon: Employee_code_icon },
        { key: "emp_name", value: "Employee Name" , readOnly:true , icon:Employee_name_icon },
        { key: "client_id", value: "Organization ID" ,readOnly:true , icon: Client_id_icon},
        { key: "unit_id", value: "Branch ID" ,readOnly:true , icon: Branch_id_icon},
        { key: "effective_date", value: "Effective Date" , icon: Payment_month_icon},
        { key: "basic", value: "Basic" , icon: Basic_icon},
        { key: "special_allowance", value: "Special Allowance" ,icon: Special_allowance_icon},
        { key: "DA", value: "DA" ,icon: DA_icon},
        { key: "hra", value: "HRA" ,icon: HRA_icon},
        { key: "st_bonus", value: "ST Bonus" ,icon: ST_bonus_icon},
        { key: "subsistanceAllowance", value: "Subsistance Allowance" ,icon: subsistence_allowance_icon},
        { key: "medical_allowance", value: "Medical Allowance" , icon: Medical_Allowance_icon},
        { key: "maternityBenefit", value: "Maternity Benefit" , icon: Maternity_Benefits_icon},
        { key: "nfh", value: "NFH" ,icon: NFH_icon},
        { key: "ot", value: "OT" ,icon: OT_icon},
        { key: "service_weightage", value: "Service Weightage" ,icon: Service_weightage_icon},
        { key: "society", value: "Society" ,icon: Society_icon},
        { key: "salary_advance", value: "Salary Advance" ,icon: Salary_advance_icon},
        { key: "conveyance", value: "Conveyance" , icon: Conveyance_icon},
        { key: "comp_others", value: "Comp Others" ,icon: Comp_others_icon},
        { key: "gross_salary", value: "Gross Salary" , icon: Gross_salary_icon},
        { key: "ESI", value: "ESI" , icon: ESI_icon},
        { key: "PF", value: "PF" ,icon: PF_icon},
        { key: "PT", value: "PT" ,icon: PT_icon},
        { key: "TDS", value: "TDS" ,icon: TDS_icon},
        { key: "Insurance", value: "Insurance" ,icon: Insurance_icon},
        { key: "damages_loss", value: "Damages Loss" , icon: Damage_loss_icon},
        { key: "fines", value: "Fines" ,icon: Fines_icon},
        { key: "LWF", value: "LWF" ,icon: LWF_icon},
        { key: "others", value: "Others" ,icon: others_icon},
        { key: "total_deduction", value: "Total Deduction" ,icon: Total_deduction_icon},
        { key: "net_pay", value: "Net Pay" ,icon: Net_pay_icon},
        { key: "mode_of_pay", value: "Mode Of Payment" ,icon: Mode_of_pay_icon},
        // { key: "p_month", value: "Payment Month" ,icon: Payment_month_icon},
    ];
    const [actionChecked, setActionChecked] = useState("");
    const fetchdata = async () => {
        if (!date) return;
        setLoading(true);
        try {
            const response = await dispatch(getCtcMaster(date));
            const data = Array.isArray(response?.data) ? response.data : [];
            setGetData(data);
        } catch (err) {
            console.error("Failed to fetch CTC master:", err);
            setGetData([]);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchdata();
    }, [dispatch, date]);


    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);
    //         try {
    //             const response = await dispatch(uploadCtcMasterFile(file));
    //             console.log("upload employee master response", response);
    //             if (response.success == true) {
    //                 showSnackbar(response.message.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {
    //                 showSnackbar(response.message, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };
   
   


        const downloadBase64Excel = (contentBase64, filename) => {
        try {
            const byteCharacters = atob(contentBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || 'ctc_master_failed_rows.xlsx';
            a.click();
            URL.revokeObjectURL(url);
        } catch (e) {
            console.error('Download failed:', e);
            showSnackbar('Failed to download error file', 'error');
        }
    };

    const handleFileUpload = async () => {
        if (file) {
            setLoading(true);
            try {
                const response = await dispatch(uploadCtcMasterFile(file));
                console.log("upload ctc master response", response);                
                if (response.success == true) {
                    const msg = response.message;
                    showSnackbar(msg.message || 'Upload completed', 'success');
                    setLoading(false);
                    fetchdata();
                    setFile(null);
                    setActionChecked("create");
                    if (msg.error_file && msg.error_file.content_base64) {
                        downloadBase64Excel(msg.error_file.content_base64, msg.error_file.filename);
                    }
                } else {
                    const err = response.message;
                    const displayError = Array.isArray(err) ? err.slice(0, 3).join('; ') + (err.length > 3 ? ` ... and ${err.length - 3} more` : '') : (err && err.error) || err || 'Upload failed';
                    showSnackbar(displayError, 'warning');
                    setLoading(false);
                }
            } catch (error) {
                showSnackbar('An error occurred', 'error');
                setLoading(false);
            }
        }
    };

   
    const submitdelete = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(multiDeleteCtcMasterFile(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }

    }

    const handleSaveClick = async (e) => {
        const positiveNumbers = /^$|^(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/
        const basic = editedValues.basic?.trim();
        if (basic && !positiveNumbers.test(basic)) {
            showSnackbar("Basic Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const specialAllowance = editedValues.special_allowance?.trim();
        if (specialAllowance && !positiveNumbers.test(specialAllowance)){
            showSnackbar("Special Allowance Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const DA = editedValues.DA?.trim();
        if (DA && !positiveNumbers.test(DA)){
            showSnackbar("DA Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const HRA = editedValues.hra?.trim();
        if (HRA && !positiveNumbers.test(HRA)){
            showSnackbar("HRA Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const stBonus = editedValues.st_bonus?.trim();
        if (stBonus && !positiveNumbers.test(stBonus)){
            showSnackbar("ST Bonus Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const SubsistanceAllowance = editedValues.subsistanceAllowance?.trim();
        if (SubsistanceAllowance && !positiveNumbers.test(SubsistanceAllowance)){
            showSnackbar("Subsistance Allowance Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const MedicalAllowance = editedValues.medical_allowance?.trim();
        if (MedicalAllowance && !positiveNumbers.test(MedicalAllowance)){
            showSnackbar("Medical Allowance Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const MaternityBenefits = editedValues.maternityBenefit?.trim();
        if (MaternityBenefits && !positiveNumbers.test(MaternityBenefits)){
            showSnackbar("Maternity Benefit Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const NFH = editedValues.nfh?.trim();
        if (NFH && !positiveNumbers.test(NFH)){
            showSnackbar("NFH Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const OT = editedValues.ot?.trim();
        if (OT && !positiveNumbers.test(OT)){
            showSnackbar("OT Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;    
        }
        const ServiceWeightage = editedValues.service_weightage?.trim();
        if (ServiceWeightage && !positiveNumbers.test(ServiceWeightage)){
            showSnackbar("Service Weightage Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const Society = editedValues.society?.trim();
        if (Society && !positiveNumbers.test(Society)){ 
            showSnackbar("Society Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const SalaryAdvance = editedValues.salary_advance?.trim();
        if (SalaryAdvance && !positiveNumbers.test(SalaryAdvance)){ 
            showSnackbar("Salary Advance Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const Conveyance = editedValues.conveyance?.trim();
        if (Conveyance && !positiveNumbers.test(Conveyance)){
            showSnackbar("Conveyance Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;        
        }
        const CompOthers = editedValues.comp_others?.trim();
        if (CompOthers && !positiveNumbers.test(CompOthers)){
            showSnackbar("Comp Others Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;             
        }
        const GrossSalary = editedValues.gross_salary?.trim();
        if (!GrossSalary){
            showSnackbar("Gross Salary Cannot be Empty","warning");
            return;
        }
        else if (GrossSalary && !positiveNumbers.test(GrossSalary)){
            showSnackbar("Gross Salary Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const ESI = editedValues.ESI?.trim();
        if (ESI && !positiveNumbers.test(ESI)){
            showSnackbar("ESI Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;
        }
        const PF = editedValues.PF?.trim();
        if (PF && !positiveNumbers.test(PF)){
            showSnackbar("PF Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;            
        }
        const PT = editedValues.PT?.trim();
        if (PT && !positiveNumbers.test(PT)){
            showSnackbar("PT Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;              
        }
        const TDS = editedValues.TDS?.trim();
        if (TDS && !positiveNumbers.test(TDS)){
            showSnackbar("TDS Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;            
        }
        const Insurance = editedValues.Insurance?.trim();
        if (Insurance && !positiveNumbers.test(Insurance)){
            showSnackbar("Insurance Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;             
        }
        const DamageLoss = editedValues.damages_loss?.trim();
        if (DamageLoss && !positiveNumbers.test(DamageLoss)){
            showSnackbar("Damage Loss Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;             
        }
        const Fines = editedValues.fines?.trim();
        if (Fines && !positiveNumbers.test(Fines)){
            showSnackbar("Fines Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;               
        }
        const LWF = editedValues.LWF?.trim();
        if (LWF && !positiveNumbers.test(LWF)){
            showSnackbar("LWF Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;              
        }
        const Others = editedValues.others?.trim();
        if (Others && !positiveNumbers.test(Others)){
            showSnackbar("Others Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return            
        }
        const TotalDeduction = editedValues.total_deduction?.trim();
        if (!TotalDeduction){
            showSnackbar("Total Deduction cannot be empty","warning");
            return;
        }
        else if (TotalDeduction && !positiveNumbers.test(TotalDeduction)){
            showSnackbar("Total Deduction Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;                 
        }
        const NetPay = editedValues.net_pay?.trim();
        if (!NetPay){
            showSnackbar("Net Pay Cannot be Empty","warning");
            return;
        }
        else if (NetPay && !positiveNumbers.test(NetPay)){
            showSnackbar("Net Pay Value is Invalid. Please enter a valid positive number (up to 2 decimal places). Negative values are not allowed.","warning");
            return;              
        }       
        const modeOfPaymentRegex = /^[a-zA-Z\s]+$/;
        const modeOfPayment = editedValues.mode_of_pay?.trim();
        if(modeOfPayment && !modeOfPaymentRegex.test(modeOfPayment)) {
            showSnackbar("Invalid Mode of Payment. Only alphabetic characters and spaces are allowed.", "warning");   
            return;
        }
        setLoading(true);
        try {
            const response = await dispatch(updateCtcMasterById(editedValues.id, editedValues));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const handledeleteClickOpenalert = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(deleteCtcMasterById(id));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());    
            const rawPermissions = response?.data?.permissions;
    
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                    ? JSON.parse(rawPermissions[0])
                    : rawPermissions;
    
            parsedPermissions.forEach((item) => {
                const { section, module, sub_module } = item;
    
                if (section === "InputMatrix" && module === "InputMatrix") {
                    const employeePermission = sub_module.find(sub => sub.name === 'CTC Master');
                    if (employeePermission?.action) {
                        setCreateData(employeePermission.action.create);
                        setEditData(employeePermission.action.edit);
                        setDeleteData(employeePermission.action.delete);
                    }
                }
            });
    
        } catch (err) {
            console.error("Failed to fetch permissions:", err);
        }
    };
    
    const fetchcurrmonth = async () => {
        try {
            const response = await dispatch(getCurrentMonth());
            if(date === new Date(response.data[0].current_month).toISOString().split('T')[0]){
                getUserPermission();
            }
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    };
    useEffect(() => {
        fetchcurrmonth();
    }, [dispatch]);
    return (
        <div className='container-fluid'>
            {/* <Reusabletable
                data={getData}
                header={header}
                setFile={setFile}
                handleFileUpload={handleFileUpload}
                submitdelete={submitdelete}
                handleSaveClick={handleSaveClick}
                setEditableRow={setEditableRow}
                editableRow={editableRow}
                setEditedValues={setEditedValues}
                editedValues={editedValues}
                handledeleteClickOpenalert={handledeleteClickOpenalert}
                title={'CTC Master'}
                setLoading={setLoading}
                filestemp={files}
                showSnackbar={showSnackbar}
                date={date}
            /> */}
            
            {createData ? 
            // <ImportFileform
            //     setFiledata={setFile}
            //     title={'CTC Master'}
            //     filestemp={files}
            //     handleFileUpload={handleFileUpload}

            // />
            <ImportFileformInputMatrix
                setFiledata={setFile}
                title={'CTC Master'}
                filestemp={files}
                handleFileUpload={handleFileUpload}
                date={date}
                File={file}
            />:<ImportFileformInputMatrixclientData
                date={date}
                
            />
            }
            <EditableTable
            
            header={header}
            mainIcon={mainicon}
            title={'CTC Master'}
            data={getData}
            setEditableRow={setEditableRow}
            setEditedValues={setEditedValues}
            handledeleteClickOpenalert={handledeleteClickOpenalert}
            editableRow={editableRow}
            setLoading={setLoading}
            editedValues={editedValues}
            getEditPermission = {editData}
            getDeletePermission = {deleteData}
            date={date}
            submitdelete={submitdelete}
            handleSaveClick={handleSaveClick}
            showSnackbar={showSnackbar}
            mainIconColor={"#4ad991"}
            actionChecked={actionChecked}
            setActionChecked={setActionChecked}
            createOrfilterComp={
                <></>
            }
            />
        </div>
    )
}

export default CtcMaster
